import { useCompanyCRUDActions } from '@mm/state/actions/CompanyCRUDActions';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import {
  isFacebookUserSelector,
  selectSessionSelector,
} from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OnboardingPageLoadingIndicator from '../../common/OnboardingPageLoadingIndicator/OnboardingPageLoadingIndicator';
import { WelcomePage } from './components/WelcomePage/WelcomePage';
import './NewUserInfoFlow.scss';
import { useRegisterSignupEvent } from '../../../../hooks/use-register-signup-event';
import { UTMTags } from '@mm/hooks';
import { CustomerQualificationLayout } from '../../../../../modules/LoginRouter/components/CustomerQualificationFlow/CustomerQualificationFlow';

export const NewUserInfoFlow = () => {
  const activeCompany = useSelector(activeCompanySelector);
  const isFBUser = useSelector(isFacebookUserSelector);
  const { userAttributes, id: userId } = useSelector(selectSessionSelector);
  const [busy, setBusy] = useState(false);
  const defaultStep = userAttributes.requestedDemo
    ? 3
    : activeCompany && !isFBUser
    ? 2
    : 1;
  const [step, setStep] = useState(defaultStep);

  const { registerSignUpEventWithTracking } = useRegisterSignupEvent();
  const { update } = useCompanyCRUDActions();
  const { updateUserAttributes } = useUsersCRUDActions();

  const utmObj = UTMTags.get();
  const hasAgencyUtmSource = utmObj?.utmSource === 'agency';

  const registerSignUpEvent = () => {
    registerSignUpEventWithTracking({
      nextOnboardingStep: OnboardingSignupStep.NONE,
      skipRedirect: false,
      audienceExtractorChannel: isFBUser ? 'facebook' : undefined,
    });
  };

  const updateCompany = async (
    name: string,
    businessEmail: string,
    website: string,
    phoneNumber: string,
    businessType?: string,
    smsConsent?: boolean,
    isAgency?: boolean,
    isUsingHighLevel?: boolean,
  ) => {
    if (activeCompany) {
      const { id } = activeCompany;
      setBusy(true);
      await update({
        id,
        name,
        businessEmail,
        website,
        phoneNumber,
        businessType,
      });
      setBusy(false);

      if (smsConsent || isAgency || hasAgencyUtmSource || isUsingHighLevel) {
        await updateUserAttributes(id, userId, {
          ...(isAgency && { agency: hasAgencyUtmSource || isAgency }),
          ...(isUsingHighLevel && { gohighlevel: isUsingHighLevel }),
          ...(smsConsent && { smsConsent }),
          ...utmObj,
        });
      }

      setStep(2);
    }
  };

  useEffect(() => {
    // old users who stopped on any onboarding step
    if (
      (userAttributes?.onboardingCompanyInfoStep || 0) > 1 &&
      userAttributes.onboardingSignupStep === OnboardingSignupStep.USER_INFO
    ) {
      registerSignUpEvent();
    }
  }, []);

  return (
    <div className="user-info-flow">
      <CustomerQualificationLayout step={step}>
        {isFBUser && activeCompany && (
          <WelcomePage onStartPress={updateCompany} company={activeCompany} />
        )}
      </CustomerQualificationLayout>
      <OnboardingPageLoadingIndicator isLoading={busy} />
    </div>
  );
};
